// Dynamically load click-to-source only during development
void Promise.all([
  import("#scripts/lib/dev/click-to-source.client.ts"),
  import("#scripts/lib/dev/addDataLocListeners.tsx"),
  import("#scripts/lib/dev/openInDevEditor.ts"),
]).then(([{ initClickToSource }, { addDataLocListeners }, { openInDevEditor }]) => {
  initClickToSource();
  addDataLocListeners(document.body, ({ file, line, column }) => {
    let path = file;
    if (line) {
      path += `:${line}`;
      if (column) path += `:${column}`;
    }
    openInDevEditor(path);
  });
});
